import { _ as t } from "./index.es261.js";
import { i as a } from "./index.es416.js";
var r = t, s = a, i = "[object Set]";
function o(e) {
  return s(e) && r(e) == i;
}
var _ = o;
export {
  _
};
//# sourceMappingURL=index.es405.js.map
